import React, { useEffect, useState, lazy } from "react";
import MenuLayouts from "../layouts/menu.layout";
import BannerComponent from "../components/home/banner.component";
import FooterLayouts from "../layouts/footer.layout";
import {
  HomeBanner,
  HomeCallToAction,
  HomePortafolio,
  MetaData,
} from "../components/conexion/home.conexion";
import BtnFloatingLayout from "../layouts/btn_flotante.layout";
import { lastNewsforCategories } from "../components/conexion/blogs.conexion";
import LazyPortafolio from "../lazy/home/portafolio.lazy";
import LazyBlog from "../lazy/home/blog.lazy";
import LazyOther from "../lazy/home/other_page.lazy";
import LazySuscribe from "../lazy/home/suscribe.lazy";
import { useLocation } from "react-router-dom";


// Placeholder del Banner
const BannerPlaceholder = () => (
  <div
    className="banner-home-component placeholder"
    style={{
      height: "90vh",
      minHeight: "600px",
      backgroundColor: "#e0e0e0",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      position: "relative"
    }}
  >
    <div style={{ color: "#999", fontFamily: "sans-serif" }}>Cargando banner...</div>
  </div>
);

// Placeholder del Portafolio
const PortafolioPlaceholder = () => (
  <div className="portafolio-home-component placeholder">
    <div className="title-portafolio-home-component">
      <div className="skeleton-text" style={{ width: "200px", height: "40px" }} />
    </div>
    <div className="cards-portafolio-home-component">
      {[1, 2, 3].map(i => (
        <div key={i} className="skeleton-card" style={{
          width: "100%",
          height: "700px",
          marginBottom: "20px",
          borderRadius: "20px",
          backgroundColor: "#e0e0e0"
        }} />
      ))}
    </div>
  </div>
);

// Placeholder del Blog
const BlogPlaceholder = () => (
  <div className="blog-home-component placeholder">
    <div className="title-blog-home-component">
      <div className="skeleton-text" style={{ width: "150px", height: "40px" }} />
    </div>
    <div className="items-blog-home-component">
      {[1, 2, 3, 4].map(i => (
        <div key={i} className="skeleton-blog-card" style={{
          width: "calc(25% - 20px)",
          height: "550px",
          margin: "0px 10px",
          borderRadius: "20px",
          backgroundColor: "#e0e0e0"
        }} />
      ))}
    </div>
  </div>
);

// Placeholder de Other Page
const OtherPlaceholder = () => (
  <div className="other-page-home-component placeholder">
    <div className="title-other-page-home-component">
      <div className="skeleton-text" style={{ width: "180px", height: "40px" }} />
    </div>
    <div className="pages-other-page-home-component">
      {[1, 2, 3].map(i => (
        <div key={i} className="skeleton-other-card" style={{
          width: "calc(50% - 20px)",
          height: "200px",
          margin: "10px",
          borderRadius: "20px",
          backgroundColor: "#e0e0e0"
        }} />
      ))}
    </div>
  </div>
);

const HomePage: React.FC = () => {
  const [dataBanner, setDataBanner] = useState([]);
  const [dataPortafolio, setDataPortafolio] = useState([]);
  const [dataCallToAction, setDataCallToAction] = useState([]);
  const [visibleHeight, setVisibleHeight] = useState(0);
  const [newsForCategories, setNewsForCategories]: any = useState([]);
  const [isLoadingBanner, setIsLoadingBanner] = useState(true);
  const [isLoadingOther, setIsLoadingOther] = useState(true);
  const location = useLocation();

  // 1) Primer efecto: carga SOLO el banner
  useEffect(() => {
    const controller = new AbortController();

    const fetchBannerData = async () => {
      setIsLoadingBanner(true);
      try {
        const res = await HomeBanner();
        setDataBanner(res.data.data);
      } catch (error: any) {
        if (error.name !== "AbortError") {
          console.error("Error cargando banner:", error);
        }
      } finally {
        setIsLoadingBanner(false);
      }
    };

    fetchBannerData();

    return () => controller.abort();
  }, []);

  // 2) Segundo efecto: carga lo demás
  useEffect(() => {
    const controller = new AbortController();

    const fetchOtherData = async () => {
      setIsLoadingOther(true);
      try {
        const [portafolioRes, callToActionRes, newsRes] = await Promise.all([
          HomePortafolio(),
          HomeCallToAction(),
          lastNewsforCategories(),
        ]);

        setDataPortafolio(portafolioRes.data.data);
        setDataCallToAction(callToActionRes.data.data);

        let posts: any = [];
        if (newsRes?.data?.data[0]?.Categories) {
          newsRes.data.data[0].Categories.forEach((element: any) => {
            element.posts.forEach((pos: any) => {
              pos.category_id = element.category_id;
              pos.category = element.category;
              posts.push(pos);
            });
          });
        }

        const sortedPosts = posts.sort(
          (a: any, b: any) =>
            new Date(b.creation_datetime).getTime() -
            new Date(a.creation_datetime).getTime()
        );
        setNewsForCategories(sortedPosts.slice(0, 3));
      } catch (error) {
        console.error("Error cargando datos:", error);
      } finally {
        setIsLoadingOther(false);
      }
    };

    fetchOtherData();

    return () => controller.abort();
  }, []);

  return (
    <>
      <MenuLayouts
        className="home-page"
        active=""
        setVisibleHeight={setVisibleHeight}
        visibleHeight={visibleHeight}
      />
      <div className="home-page">
        <h1
          style={{ position: "absolute", opacity: "0", pointerEvents: "none" }}
        >
          Hyundai Colombia - Innovación, Tecnología y Movilidad para el Futuro
        </h1>

        <div className="home-page-mascara"></div>

        {/* Banner con placeholder mientras carga */}
        {isLoadingBanner || dataBanner.length === 0 ? (
          <BannerPlaceholder />
        ) : (
          <BannerComponent dataBanner={dataBanner} />
        )}

        {/* Portafolio con placeholder mientras carga */}
        {isLoadingOther || dataPortafolio.length === 0 ? (
          <PortafolioPlaceholder />
        ) : (
          <LazyPortafolio portafolios={dataPortafolio} />
        )}

        {/* Blog con placeholder mientras carga */}
        {isLoadingOther || newsForCategories.length === 0 ? (
          <BlogPlaceholder />
        ) : (
          <LazyBlog newsForCategories={newsForCategories} />
        )}

        {/* Other con placeholder mientras carga */}
        {isLoadingOther || dataCallToAction.length === 0 ? (
          <OtherPlaceholder />
        ) : (
          <LazyOther callToAction={dataCallToAction} />
        )}

        <LazySuscribe />
      </div>
      <BtnFloatingLayout reserva="https://reservas.hyundaicolombia.co/" />
      <FooterLayouts />
    </>
  );
};

export default HomePage;